import dayjs from 'dayjs'

/**
 *  @description
 *  用於圖表跨年份的部分需要顯示date list 年尾後一天，與年初第一天
 *  spec : https://www.notion.so/ikala/e43ecc134e9047c4b24cdcdf1f0f6b48?pvs=4#db098fc21ba4485ea4d750dcb15e9839
 *  e.g. ['2023/12/22', '2023/12/29', '2024/03/01', '2024/03/02'] => ['2023/12/29', '2024/03/01']
 * */
export const getBoundaryDateSet = (dates: string[]): Set<string> => {
  const result: string[] = []

  for (let i = 0; i < dates.length; i++) {
    const current = dayjs(dates[i])
    const next = i + 1 < dates.length ? dayjs(dates[i + 1]) : null
    const prev = i - 1 >= 0 ? dayjs(dates[i - 1]) : null

    if (
      (!prev && !!next && current.year() !== next.year()) || // 第一個日期且與下一個日期不同年
      (!next && !!prev && current.year() !== prev.year()) || // 最後一個日期且與前一個日期不同年
      (!!prev && current.year() !== prev.year()) || // 與前一個日期不同年
      (!!next && current.year() !== next.year()) // 與後一個日期不同年
    ) {
      result.push(dates[i])
    }
  }

  return new Set(result)
}
